import { makeStyles } from '@material-ui/core';

export const useStylesTable = makeStyles((theme) => ({
  table: {
    '& .MuiTableRow-root': {
      '& > *:nth-child(2)': {
        width: '240px',
        '& p': {
          maxWidth: '100%',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          '&::after': {
            content: '""',
            display: 'block',
          },
        },
      },
    },
  },
}));
